import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ResourceInfoDc } from "@evergis/api";

import { dataUriToFile, getImageDataUri } from "../../../../utils/image";
import { ResourceMetaUpdate } from "../../../../hooks/useResourceMeta";

export const useUpdateMetaEffect = (resource: ResourceInfoDc, previewUrl: string, updateMeta: ResourceMetaUpdate) => {
  const { t } = useTranslation("dialogs");

  useEffect(() => {
    if (!resource) {
      return;
    }

    const { alias, description, preview } = resource;

    updateMeta.setAlias(`${alias} ${t("copyResource.aCopy")}`);
    updateMeta.setDescription(description);

    if (preview && previewUrl) {
      getImageDataUri(previewUrl).then((dataUri: string) => {
        const file = dataUriToFile(dataUri, preview);

        updateMeta.setPreview(dataUri, file);
      });
    }
  }, [resource, previewUrl, t]);
};
